//
// The API's approval DTOs in camelCase (Core/Data/DTOs/Approval/ApprovalDTOs.cs): GET approvals/mine,
// GET approvals/requested, GET approvals/{id} and the answer of POST approvals/{id}/approve|reject.
//

export class ApprovalDecisionDTO {
  approvalDecisionId: string;

  deciderUserId: string;

  deciderName?: string;

  isSystem: boolean;

  // ApprovalRequestDecision: 0 Approved, 1 Rejected
  decision: number;

  comment?: string;

  createdAt: string;

  constructor() {
    this.approvalDecisionId = '';
    this.deciderUserId = '';
    this.isSystem = false;
    this.decision = 0;
    this.createdAt = '';
  }
}

export class ApprovalRequestDTO {
  approvalRequestId: string;

  executionId: string;

  toolCallId: string;

  skillId?: string;

  skillVersionId?: string;

  skillName?: string;

  skillVersion?: string;

  requesterUserId: string;

  requesterName?: string;

  reason?: string;

  // ApproverMode: 0 Requester, 1 Group
  approverMode: number;

  approverGroupId?: string;

  approverGroupName?: string;

  // ApprovalRequestStatus: 0 Pending, 1 Approved, 2 Rejected, 3 Expired, 4 Withdrawn (its run was canceled while it waited)
  status: number;

  createdAt: string;

  expiresAt: string;

  decidedAt?: string;

  toolName?: string;

  operation?: string;

  capabilityName?: string;

  canDecide: boolean;

  decisions?: ApprovalDecisionDTO[];

  constructor() {
    this.approvalRequestId = '';
    this.executionId = '';
    this.toolCallId = '';
    this.requesterUserId = '';
    this.approverMode = 1;
    this.status = 0;
    this.createdAt = '';
    this.expiresAt = '';
    this.canDecide = false;
  }
}

export class ApprovalPayloadDTO {
  action?: string;

  downstreamSystem?: string;

  toolName?: string;

  operation?: string;

  // ToolCallAccess: 0 Read, 1 Write
  access: number;

  // compact JSON text, secret-looking values masked, at most 8,000 characters
  arguments?: string;

  argumentsTruncated: boolean;

  capabilityId?: string;

  capabilityKey?: string;

  capabilityName?: string;

  // CapabilityType: 0 Mcp, 1 Https
  capabilityType: number;

  // ToolCallIdentityMode: 0 User, 1 Shared, 2 None
  identityMode: number;

  skillId?: string;

  skillKey?: string;

  skillName?: string;

  skillVersionId?: string;

  skillVersion?: string;

  requesterUserId?: string;

  requesterName?: string;

  ruleId?: string;

  policyId?: string;

  approverCount: number;

  constructor() {
    this.access = 1;
    this.argumentsTruncated = false;
    this.capabilityType = 0;
    this.identityMode = 2;
    this.approverCount = 0;
  }
}

export class ApprovalDetailDTO extends ApprovalRequestDTO {
  payload?: ApprovalPayloadDTO;

  relatedApprovals?: ApprovalRequestDTO[];
}

// The body of POST approvals/{id}/approve (comment optional) and /reject (comment required)
export class DecideApprovalDTO {
  comment?: string;
}
